import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [reservedinDoller, setReservedinDoller] = useState(0);
  const [reservedassets, setReservedassets] = useState([]);
  const [totalS, setTotalS] = useState(null);
  const [maalprice, setMaalPrice] = useState(0);
  const [update, setUpdate] = useState(0);
  const [user, setUser] = useState("");
  const [maalreserveUSDT, setMaalReserveUSDT] = useState(80000000);
  const [euroreserved, setEuroReserved] = useState(0);
  const [lockedEuroReserve, setLockedERUOResver] = useState("0000-00-00 00:00:00");
  const [euroReservedUSDT, setEuroReservedUSDT] = useState(0);
  const [disabledAction, setDisabledAction] = useState(false);
  const [eusd, setEUSD] = useState(0);
  const [totalMint, setTotalMint] = useState(0);
  const [totalburn, setTotalBurn] = useState(0);
  const [totalBurnETH, setTotalBurnETH] = useState(0);
  const [totalMintETH, setTotalMintETH] = useState(0);
  const [mintburnallowd, setMinBurnAllowd] = useState(0);
  const [rusdbalance, setRusdbalance] = useState(0);
  const [ninepercentreserve, setNinepercentReserve] = useState(0);
  const [btcDollarValue, setBtcDollarValue] = useState(null);
  const [btcValue, setBtcValue] = useState(null);
  const [totalSEth, setTotalSEth] = useState(null);
  const [tatalSBsc, setTotalSBsc] = useState(null);
  const [burnAlownStatus, setBurnAllowedStatus] = useState(false);
  const [selectedToken, setSelectedToken] = useState("ICUSD");

  return (
    <AppContext.Provider
      value={{
        reservedinDoller,
        reservedassets,
        maalprice,
        user,
        eusd,
        update,
        totalS,
        tatalSBsc,
        totalSEth,
        euroreserved,
        totalBurnETH,
        totalMintETH,
        lockedEuroReserve,
        euroReservedUSDT,
        burnAlownStatus,
        totalMint,
        totalburn,
        mintburnallowd,
        rusdbalance,
        ninepercentreserve,
        btcDollarValue,
        btcValue,
        disabledAction,
        maalreserveUSDT,
        selectedToken,
        setSelectedToken,
        setMaalReserveUSDT,
        setBtcDollarValue,
        setTotalBurnETH,
        setTotalMintETH,
        setDisabledAction,
        setBtcValue,
        setRusdbalance,
        setNinepercentReserve,
        setMinBurnAllowd,
        setBurnAllowedStatus,
        setTotalBurn,
        setTotalMint,
        setEuroReservedUSDT,
        setLockedERUOResver,
        setEuroReserved,
        setTotalS,
        setTotalSBsc,
        setTotalSEth,
        setUpdate,
        setEUSD,
        setUser,
        setReservedassets,
        setReservedinDoller,
        setMaalPrice
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
